import { render, staticRenderFns } from "./JoinComponent.vue?vue&type=template&id=187a7efe"
import script from "./JoinComponent.vue?vue&type=script&lang=js"
export * from "./JoinComponent.vue?vue&type=script&lang=js"
import style0 from "./JoinComponent.vue?vue&type=style&index=0&id=187a7efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports